import { useEffect, useState } from "react";

const useUTCTime = (interval = 1000) => {
  const [utcTime, setUtcTime] = useState(new Date().toUTCString());

  useEffect(() => {
    const timer = setInterval(() => {
      setUtcTime(new Date().toUTCString());
    }, interval);

    return () => clearInterval(timer);
  }, [interval]);

  return utcTime;
};

export default useUTCTime;
